/**
 * Static images under /assets are served from the CDN when NEXT_PUBLIC_ASSET_BASE_URL is
 * set at build time (e.g. https://cdn.meritlens.ai/static → .../static/assets/Icons/x.png).
 * Unset (local dev) = same-origin /assets, served from the repo's assets/ folder as before.
 */
export const ASSET_BASE_URL = (process.env.NEXT_PUBLIC_ASSET_BASE_URL ?? '').replace(/\/+$/, '')

export const asset = (path: string): string => `${ASSET_BASE_URL}${path}`

/**
 * Same-origin path for an asset URL.
 *
 * Stage and prod build with NEXT_PUBLIC_ASSET_BASE_URL pointing at the CDN, so `asset()` yields a
 * CDN URL. A role image that has not been uploaded there 404s, which is why the campaign pages fall
 * back to `/assets/...` — that directory is shipped inside the image (public/assets → ../assets) and
 * served by the same origin in every environment.
 */
export function localAssetPath(src: string): string {
  return ASSET_BASE_URL && src.startsWith(ASSET_BASE_URL)
    ? src.slice(ASSET_BASE_URL.length)
    : src
}
